import React, { useEffect } from "react";
import "./index.css";
import { AppProviders } from "app/providers";
import { Flowbite } from "flowbite-react";
import Layout from "shared/ui/layout/Layout";
import { Routing } from "pages";

function App() {
  const [dark, setDark] = React.useState(false);
  useEffect(() => {
    let dark = localStorage.getItem("theme") === "dark";
    setDark(dark);
  }, []);
  useEffect(() => {
    document.body.classList.add("bg-sky-50");
    document.body.classList.add("dark:bg-gray-800");
    document.title = "Best Barista App";
  }, []);

  return (
    <Flowbite theme={{ dark }}>
      <Layout>
        <Routing />
      </Layout>
    </Flowbite>
  );
}

export default AppProviders(App);
